module.exports = __webpack_public_path__ + "img/radio_button_checked.afd11f56.svg";